// extracted by mini-css-extract-plugin
export default {"table":"PastMembersPage_table__AQJ4h"};